"use client";

import React from "react";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const partners = [{
  name: "Đại học Xây dựng Hà Nội",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_nuce_partner.png",
  type: "Academic"
}, {
  name: "Vinaconex",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_vinaconex_partner.png",
  type: "Construction"
}, {
  name: "Coteccons",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_coteccons_partner.png",
  type: "Construction"
}, {
  name: "Delta Group",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_delta_group.png",
  type: "Construction"
}, {
  name: "Autodesk",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_autodesk_partner.png",
  type: "Technology"
}, {
  name: "Siemens",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_siemens_partner.png",
  type: "Technology"
}, {
  name: "Hòa Bình Corp",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_hoa_binh_corp.png",
  type: "Construction"
}, {
  name: "Viettel Construction",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_viettel_construction.png",
  type: "Technology"
}];
export default function StrategicPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}